module.exports = __webpack_public_path__ + "d54ffcf16728ec27bc7655c354a62921.pdf";